import { AvailableModules } from 'generated/featureDefinitions'

import { Employee } from 'modules/core/hooks/useCurrentSession'
import type { ModuleAvailabilityType } from 'modules/core/hooks/useModuleAvailability'
import hasFeature from 'modules/core/lib/hasFeature'
import { isModuleAvailabilityEnabled } from 'modules/core/lib/isModuleAvailabilityEnabled'

import { isManager } from 'modules/employees/lib/isManager'

import { hasEnpsModule } from './hasEnpsModule'
import { hasSurveysModule } from './hasSurveysModule'

export function seeInsights(
  moduleAvailabilities: ModuleAvailabilityType[],
  currentEmployee: Employee,
  canManageSurveys: boolean
): boolean {
  const surveysAndEnpsAllowsInsights = hasFeature('dev_packaging_paywalls')
    ? hasSurveysModule(moduleAvailabilities) && hasEnpsModule(moduleAvailabilities)
    : true

  return (
    hasEngagementInsightsModule(moduleAvailabilities) &&
    ((currentEmployee && isManager(currentEmployee)) || canManageSurveys) &&
    surveysAndEnpsAllowsInsights
  )
}

export function launchSurveys(
  moduleAvailabilities: ModuleAvailabilityType[],
  canManageSurveys: boolean
): boolean {
  return hasEngagementInsightsModule(moduleAvailabilities) && canManageSurveys
}

const hasEngagementInsightsModule = (moduleAvailabilities: ModuleAvailabilityType[]) => {
  return isModuleAvailabilityEnabled(moduleAvailabilities, AvailableModules.engagement_insights)
}
